class CollectionMediaToggle extends HTMLElement {
  static storageKey = 'the-limely:collection-media-view';

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.addEventListener('click', this.onClick);

    let savedView = 'product';

    try {
      savedView = sessionStorage.getItem(CollectionMediaToggle.storageKey) || 'product';
    } catch (error) {
      savedView = 'product';
    }

    this.setView(savedView === 'model' ? 'model' : 'product');
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    const button = event.target.closest('[data-media-view]');

    if (!button || !this.contains(button)) return;

    this.setView(button.dataset.mediaView);
  };

  setView(view) {
    const nextView = view === 'model' ? 'model' : 'product';

    if (nextView === 'model') {
      this.setAttribute('aria-busy', 'true');
      this.loadModelImages();
      this.removeAttribute('aria-busy');
    }

    document.documentElement.dataset.collectionMediaView = nextView;

    this.querySelectorAll('[data-media-view]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.mediaView === nextView));
    });

    try {
      sessionStorage.setItem(CollectionMediaToggle.storageKey, nextView);
    } catch (error) {
      // The view still works when storage is unavailable.
    }
  }

  loadModelImages() {
    document
      .querySelectorAll('.shopify-section--main-collection template[data-model-media-template]')
      .forEach((template) => {
        const mediaLink = template.closest('.product-card__media');

        if (!mediaLink || mediaLink.querySelector('.product-card__image--model')) return;

        const fragment = template.content.cloneNode(true);
        const image = fragment.querySelector('.product-card__image--model');

        if (!image) return;

        mediaLink.appendChild(fragment);
        template.remove();
      });
  }
}

if (!customElements.get('collection-media-toggle')) {
  customElements.define('collection-media-toggle', CollectionMediaToggle);
}
